(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('video-popup')) {
    class VideoPopup extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.video = this.querySelector('video');
        this.muteBtn = this.querySelector('[data-mute]');
        if (!this.dialog || !this.video) return;

        this.ctrl = new AbortController();
        const { signal } = this.ctrl;

        this.video.loop = this.dataset.loop === 'true';

        this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close(), { signal });
        this.muteBtn.addEventListener('click', () => this.setMuted(!this.video.muted), { signal });
        this.dialog.addEventListener('click', (e) => e.target === this.dialog && this.dialog.close(), { signal });
        this.dialog.addEventListener('close', () => this.onClose(), { signal });

        if (window.Shopify?.designMode) {
          const id = this.dataset.sectionId;
          document.addEventListener('shopify:section:select', (e) => {
            if (e.detail.sectionId !== id) return;
            window.__videoPopupSelected = id;
            this.open();
          }, { signal });
          document.addEventListener('shopify:section:deselect', (e) => {
            if (e.detail.sectionId !== id) return;
            window.__videoPopupSelected = null;
            this.dialog.close();
          }, { signal });
          // Re-open after the editor re-renders the section on a setting change
          if (window.__videoPopupSelected === id) this.open();
          return;
        }

        if (!this.shouldShow()) return;
        this.timer = setTimeout(() => this.open(), Number(this.dataset.delay) * 1000);
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        this.ctrl?.abort();
        this.unlockCtrl?.abort();
      }

      get store() {
        return this.dataset.frequency === 'session' ? sessionStorage : localStorage;
      }

      shouldShow() {
        const { frequency, key, days } = this.dataset;
        if (frequency === 'always') return true;
        try {
          const last = Number(this.store.getItem(key));
          if (!last) return true;
          return frequency === 'days' && Date.now() - last > Number(days) * 864e5;
        } catch {
          return true;
        }
      }

      markSeen() {
        if (this.dataset.frequency === 'always' || window.Shopify?.designMode) return;
        try {
          this.store.setItem(this.dataset.key, String(Date.now()));
        } catch {}
      }

      async open() {
        if (this.dialog.open) return;
        this.dialog.showModal();
        this.markSeen();
        this.video.currentTime = 0;

        // Try with sound first; browsers reject this without prior user activation
        this.video.muted = false;
        try {
          await this.video.play();
          this.sync();
        } catch {
          this.video.muted = true;
          this.sync();
          this.video.play().catch(() => {});
          this.armUnlock();
        }
      }

      // Unmute on the visitor's first genuine interaction
      armUnlock() {
        this.unlockCtrl?.abort();
        this.unlockCtrl = new AbortController();
        const opts = { capture: true, signal: this.unlockCtrl.signal };
        const unlock = (e) => {
          this.unlockCtrl.abort();
          // Let the mute button handle its own click
          if (e.target.closest?.('[data-mute]')) return;
          this.setMuted(false);
        };
        document.addEventListener('click', unlock, opts);
        document.addEventListener('keydown', unlock, opts);
      }

      setMuted(muted) {
        this.video.muted = muted;
        if (this.video.paused) this.video.play().catch(() => {});
        this.sync();
      }

      sync() {
        const muted = this.video.muted;
        this.toggleAttribute('data-muted', muted);
        this.muteBtn.setAttribute('aria-pressed', String(muted));
        this.muteBtn.setAttribute('aria-label', muted ? 'Unmute' : 'Mute');
      }

      onClose() {
        this.video.pause();
        this.unlockCtrl?.abort();
      }
    }

    customElements.define('video-popup', VideoPopup);
  }

  } catch(e) { console.error(e); }
})();
})();
